var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.116 2.625A2.628 2.628 0 003.491 5.25a2.628 2.628 0 002.625 2.625A2.628 2.628 0 008.741 5.25a2.628 2.628 0 00-2.625-2.625zm0 4.375c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.785 1.75 1.75S7.081 7 6.116 7zm0-7a5.25 5.25 0 00-5.25 5.25c0 2.117.738 2.708 4.71 8.467a.657.657 0 001.08 0c3.973-5.76 4.71-6.35 4.71-8.467 0-2.9-2.35-5.25-5.25-5.25zm0 12.96C2.307 7.45 1.741 7.013 1.741 5.25c0-1.169.455-2.267 1.282-3.094A4.346 4.346 0 016.116.875c1.169 0 2.267.455 3.094 1.281A4.346 4.346 0 0110.49 5.25c0 1.763-.566 2.2-4.375 7.71z",
    fill: "#0B0B0B"
  })));
}

export default SvgPin;